import { Chip } from '@mui/material';

export const IsInvitedFilter = (
<Chip sx={{ marginBottom: 1.5 }} 
        source="invited_by"
        label="É convidado"
        defaultValue={"-"} 
/>
)
